import { render, staticRenderFns } from "./tbmDetailAppr.vue?vue&type=template&id=789cb4e3"
import script from "./tbmDetailAppr.vue?vue&type=script&lang=js"
export * from "./tbmDetailAppr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('789cb4e3')) {
      api.createRecord('789cb4e3', component.options)
    } else {
      api.reload('789cb4e3', component.options)
    }
    module.hot.accept("./tbmDetailAppr.vue?vue&type=template&id=789cb4e3", function () {
      api.rerender('789cb4e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/appr/sai/tbm/tbmDetailAppr.vue"
export default component.exports